import React from "react";
import Productpage from "../../productpage2";
import SEO from "../../seo";

export default function PostureTherapyPTPage({ location }) {
  const data = {
    galleryImages: [
      "https://eclipsemattress.in/assets/images/products/posture-therapy/Posture-Therapy-04.png",
      "https://eclipsemattress.in/assets/images/products/posture-therapy/Posture-Therapy-01.png",
      "https://eclipsemattress.in/assets/images/products/posture-therapy/Posture-Therapy-02.png",
      "https://eclipsemattress.in/assets/images/products/posture-therapy/Posture-Therapy-03.png",
    ],
    productName: "Posture Therapy",
    productLogo:
      "https://eclipsemattress.in/wp-content/uploads/2020/01/logos-04.png",
    descriptionTitle: "",
    descriptionText:
      "Posture Therapy brings together heavy gauge Bonnell springs and a thick layer of pressure relieving, temperature sensitive Visco Elastic Memory Foam. The memory foam works on your pressure points to provide relief from pain and stress.",
    availableSizes: "7″, 7″ PT” & 9″ PT",
    category: { title: "Luxury Collection", link: "/luxury-collection" },
    points: [
      "Premium heavy gauge Bonnell Springs",
      "Thick layer of pressure-relieving, temperature-sensitive Visco Elastic Memory Foam",
      "Bamboo fabric top",
      "Most eco-friendly fabric in the world",
      "Fine silk-like softness",
      "Moisture-wicking & breathable",
      "Naturally hypoallergenic",
      "Medium-firm mattress with softest top layer & firm core",
      "Posture correction with comfort",
    ],

    featuresText: [
      "Memory Foam Quilted Top",
      "HD Eclipse Pure Foam (2 Layers)",
      "Turkish Cotton Felt",
      "PP Mesh For Durability",
      "Perimeter Foam Encasement",
      "Chiropractic Bonnell Springs",
    ],
    featuresImage:
      "https://eclipsemattress.in/assets/images/products/posture-therapy/Posture-Therapy-11.png",
    warrantyIcons: [
      "https://eclipsemattress.in/assets/images/products/posture-therapy/Posture-Therapy-06.png",
      "https://eclipsemattress.in/assets/images/products/posture-therapy/Posture-Therapy-07.png",
      "https://eclipsemattress.in/assets/images/products/posture-therapy/Posture-Therapy-08.png",
      "https://eclipsemattress.in/assets/images/products/posture-therapy/Posture-Therapy-09.png",
      "https://eclipsemattress.in/assets/images/products/posture-therapy/Posture-Therapy-10.png",
    ],
    warrantyImage:
      "https://eclipsemattress.in/assets/images/products/posture-therapy/Posture-Therapy-05.png",

    price: "₹24,799 - ₹81,399",

    relatedProducts: [
      {
        title: "Posture Care",
        img: "https://eclipsemattress.in/assets/images/product_thumbnails/posture-care.jpg",
        link: "/luxury-collection/posture-care/",
      },
      {
        title: "Coil On Coil",
        img: "https://eclipsemattress.in/assets/images/product_thumbnails/coiloncoil.jpg",
        link: "/patent-series-mattress/coil-on-coil/",
      },
      {
        title: "Harmony Ortho",
        img: "https://eclipsemattress.in/assets/images/product_thumbnails/harmonyortho.jpg",
        link: "/harmony-collection/harmony-ortho/",
      },
    ],
  };

  return (
    <div>
      <SEO
        title="Posture Therapy Memory Foam Mattress | Eclipse International"
        description={`"Shop Posture Therapy Memory foam mattress from Eclipse International with 10 years warranty bringing finest quality Bonnell springs and pressure relieving.`}
        img="https://eclipsemattress.in/assets/linkpreviews/link-preview-posturetherapy.jpg"
      />
      <Productpage product={data} location={location} />
    </div>
  );
}
